var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMessagesBubble = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 8.5a.5.5 0 0 1-.5.5h-5.5l-2 2V9h-3a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 .5.5v7ZM3.75 6h6.5M3.75 3.5h6.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgMessagesBubble);
export default ForwardRef;